import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useGetUser } from '@/reactQuery/get';
import useUserStore from '@/store/UserStore';
import useAuthStore from '@/store/AuthStore';

// Hook for fetching user data once and managing it in Zustand store
export const useFetchUser = () => {
  const { user, setRefetch } = useUserStore();

  const shouldFetch = !user;
  const { refetch } = useGetUser(shouldFetch);

  useEffect(() => {
    setRefetch(refetch);
  }, [refetch, setRefetch]);
};

// Hook for components to access user data from store
export const useUser = () => {
  const { user, isLoading, refetchUser } = useUserStore();

  return {
    user,
    isLoading,
    refetch: refetchUser,
  };
};

// Hook for logout functionality with navigation and cache clearing
export const useLogout = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { logout } = useAuthStore();

  return () => {
    logout(navigate, queryClient);
  };
};
